import { lazy } from 'react'
import ChunkLoader from "router/ChunkLoader"

const navigation = [
  {
    id: 'auth',
    navLink: '/auth',
    component: lazy(() => ChunkLoader(() => import('views/auth/LoginView'))),
    pagePermissions: ["public"],
    layout: 'BlankLayout'
  },
  {
    id: 'auth-reset',
    navLink: '/auth-reset',
    component: lazy(() => ChunkLoader(() => import('views/auth/ResetView'))),
    pagePermissions: ["public"],
    layout: 'BlankLayout'
  },
  {
    id: 'auth-force-reset',
    navLink: '/auth-force-reset',
    component: lazy(() => ChunkLoader(() => import('views/auth/LoginResetView'))),
    pagePermissions: ["public"],
    layout: 'BlankLayout'
  },
  {
    id: 'error-404',
    navLink: '/404',
    component: lazy(() => ChunkLoader(() => import('views/error/404'))),
    pagePermissions: ["public", "user"],
    layout: 'BlankLayout'
  }
]

export default navigation;
